import { t } from 'i18next'
import * as React from 'react'
import { pushRefrescoDatalayer } from '../../datalayer'
import { ParsedNodeLandingPage } from '../../drupal/types_and_parser/types'
import { CustomParsedNode } from '../drupalPage/state'
import { encodeTag, translatedCareersSlug } from '../overview/utils'
import Bubbles from '../utils/bubbles'
import { localeCountry } from '../utils/countries'
import { ExternalLink } from '../utils/external_link'
import { titleSplit } from '../utils/helpers'
import { getLangFromUrl, oldSites, updateUrlLang } from '../utils/history.mod'
import { Breadcrumb, Breadcrumbs } from './breadcrumbs.mod'
import HeroVisual from './heroVisual'
import { VideoLightbox } from './videoLightbox'

let department = ''
let country = ''
let storiesPageSlug = ['/stories'] // Can add more slugs for other langauges

export const PageHeader = (
  departments: string[],
  countries: string[],
  breadcrumbs: Array<Breadcrumb>,
  node: CustomParsedNode
): JSX.Element =>
  node.bundle == 'landing_page'
    ? PageHeaderAux(departments, countries, breadcrumbs, node)
    : PageHeaderAux([], [], breadcrumbs, node)

const PageHeaderAux = (
  departments: string[],
  countries: string[],
  breadcrumbs: Array<Breadcrumb>,
  p: CustomParsedNode
): JSX.Element => {
  if (p.bundle == 'story')
    // breadcrumbs = breadcrumbs.insert(1, {
    //   url: `/${getLangFromUrl().toString()}/stories`,
    //   title: "Stories"
    // })

    // if (storiesPageSlug.includes(p.path)) {
    //   breadcrumbs = breadcrumbs.insert(1, {
    //     url: `/${getLangFromUrl().toString()}`,
    //     title: "Home" // translate Title Maybe??
    //   })
    // }

    var selected_vacancyDepartmentTags: string
  var selected_vacancyCountryTags: string

  var imageLabel = ''
  if (p.bundle == 'page' || p.bundle == 'landing_page') {
    imageLabel = p.field_list_image || ''
  }

  const refrescoBranding = p?.bundle === 'page' ? p.field_refresco_branding : false

  return (
    <>
      {p.bundle == 'homepage' && homepagePageHeader(p)}

      {p.bundle == 'landing_page' &&
        landingpageHeader(p, departments, countries, selected_vacancyDepartmentTags, selected_vacancyCountryTags)}
      {/* Stories overview */}
      {storiesPageSlug.includes(p.path) && (
        <>
          {' '}
          <header className={`pageheader ${headerBackgroundClass(imageLabel)}`}>
            <div className="pageheader__inner">
              <div className="pageheader__content container container--m">
                <div className="pageheader__message">
                  <div className="pageheader__header">
                    <h1 className="pageheader__title">{titleSplit(p.label)}</h1>
                    {p.bundle == 'page' && (
                      <div className="pageheader__intro" dangerouslySetInnerHTML={{ __html: p.field_introduction }} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </header>
          {/* {breadcrumbs.count() > 0 && storiesPageSlug.includes(p.path) &&
                <div className="pageheader__breadcrumbs pageheader__breadcrumbs--compact"><Breadcrumbs breadcrumbs={breadcrumbs} /></div>
              } */}
        </>
      )}

      {p.bundle != 'landing_page' && p.bundle != 'homepage' && !storiesPageSlug.includes(p.path) ? (
        <>
          <header
            className={`pageheader pageheader ${
              p.field_introduction_image?.field_media_image?.image ? 'with' : 'no'
            }-image ${p.bundle == 'story' ? 'pageheader--flat' : ''} ${headerBackgroundClass(imageLabel)}`}
          >
            <div className="pageheader__inner">
              <div className={`container ${!refrescoBranding ? 'container--m pageheader__content' : 'container--s'}`}>
                <div className={`${!refrescoBranding ? 'pageheader__message' : 'pageheader_nobranding_message'}`}>
                  {/* {breadcrumbs.length > 0 && p.bundle == 'story' && (
                    <div className="pageheader__breadcrumbs pageheader__breadcrumbs--compact">
                      <Breadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                  )} */}
                  <div className="pageheader__header">
                    <h1 className="pageheader__title">{titleSplit(p.label)}</h1>
                    {p.bundle == 'page' && (
                      <div className="pageheader__intro" dangerouslySetInnerHTML={{ __html: p.field_introduction }} />
                    )}
                  </div>
                </div>
                {p.bundle == 'story' && p.field_introduction_image?.field_media_image?.image && (
                  <HeroVisual
                    hasCMSImg={true}
                    hasVacancyImg={false}
                    image={p.field_introduction_image?.field_media_image}
                  />
                )}
              </div>
            </div>
          </header>
          {breadcrumbs.length > 0 && !refrescoBranding && (
            <Breadcrumbs breadcrumbs={breadcrumbs} />
          )}
        </>
      ) : null}
    </>
  )
}

const homepagePageHeader = (p: CustomParsedNode) => {
  let hasVideo = false
  if (p.bundle != 'homepage') return <></>
  if (p.field_media) hasVideo = true
  let image_label = p.field_list_image

  return (
    <header className={`pageheader pageheader--homepage ${headerBackgroundClass(image_label)}`}>
      <div className="pageheader__inner">
        {/* <Bubbles extraClassNames="pageheader__bubbles" /> */}
        <div className="pageheader__content container container--m">
          <div className="pageheader__message">
            <div className="pageheader__header">
              <h1 className="pageheader__title">{titleSplit(p.label)}</h1>
              {p.bundle == 'homepage' && (
                <div className="pageheader__intro" dangerouslySetInnerHTML={{ __html: p.field_introduction }} />
              )}
            </div>
            {p.bundle == 'homepage' && (p.field_button || hasVideo) && (
              <div className="pageheader__clickables">
                {p.field_button && (
                  <div className="pageheader__clickable">
                    <ExternalLink
                      type="link"
                      className="button button--primary"
                      to={updateUrlLang(p.field_button.url, getLangFromUrl())}
                    >
                      {p.field_button.title}
                    </ExternalLink>
                  </div>
                )}
                {p.field_media && (
                  <div className="pageheader__clickable">
                    <VideoLightbox
                      provider={p.field_media.type == 'youtube' ? p.field_media.type : 'vimeo'}
                      videoURL={p.field_media.value}
                      buttonText={p.field_video_play_text ? p.field_video_play_text : 'Play'}
                      closeText={p.field_video_close_text ? p.field_video_close_text : 'Close'}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  )
}

// SREFC-131: the header used to show a fixed overlay image in a column beside
// the text. It now shows one of seven fixed background shapes behind the whole
// header instead. The CMS keeps the same field_list_image dropdown and the same
// stored values, so existing content needs no migration; only the artwork each
// value points at has changed.
const headerBackgrounds: { [value: string]: string } = {
  mint: 'pageheader--bg-01',
  orange: 'pageheader--bg-02',
  lemon: 'pageheader--bg-03',
  lime: 'pageheader--bg-04',
  coke: 'pageheader--bg-05',
  vacancies: 'pageheader--bg-06',
  esg: 'pageheader--bg-07'
}

function headerBackgroundClass(str: string): string {
  if (!str) return ''
  return headerBackgrounds[str.toLowerCase()] || headerBackgrounds.mint
}

const landingpageHeader = (
  p: ParsedNodeLandingPage,
  departments: string[],
  countries: string[],
  selected_vacancyCountryTags: string,
  selected_vacancyDepartmentTags: string
) => {
  const lang = getLangFromUrl()
  let currentSite: string
  let isSelectedCountry: boolean = false
  let countryDummyFilterName: string // Benelux or North America, incase of Benelux we later can add NL and BE to filter as example.

  const isBeneluxOrNorthAmerica =
    lang == 'nl' || lang == 'be_nl' || lang == 'be_fr' || lang == 'na' || lang == 'na-fr' || lang == 'na-es'
  const isBenelux = lang == 'nl' || lang == 'be_nl' || lang == 'be_fr'
  const isNorthAmerica = lang == 'na' || lang == 'na-fr' || lang == 'na-es'
  const isAustralia = window.location.host.endsWith('.au')
  const tagBenelux = 'Benelux'
  const tagNorthAmerica = 'North America'
  const tagAustralia = 'Australia'

  if (lang == 'es' || lang == 'de' || lang == 'uk' || lang == 'pl' || lang == 'fi' || lang == 'it' || lang == 'fr') {
    currentSite = oldSites.getIn([lang == 'es' ? 'ib' : lang])
    isSelectedCountry = currentSite.startsWith(window.location.origin)
  }

  if (isBenelux) {
    countryDummyFilterName = tagBenelux
  }
  if (isNorthAmerica) {
    countryDummyFilterName = tagNorthAmerica
  }
  if (isAustralia) {
    countryDummyFilterName = tagAustralia
  }

  let image_label = p.field_list_image

  return (
    <>
      <header className={`pageheader ${headerBackgroundClass(image_label)}`}>
        <div className="pageheader__inner">
          <div className="pageheader__content container container--m">
            <div className="pageheader__message">
              <div className="pageheader__header">
                <h1 className="pageheader__title">{titleSplit(p.label)}</h1>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="container container--m grid--gutter">
        <div className="page__intro" dangerouslySetInnerHTML={{ __html: p.field_introduction }} />
      </div>

      <div className="page__search-bar">
        <div className="container container--m grid--gutter">
          <div className="search-bar">
            <div className="search-bar__inner grid--gutter">
              <form
                id="formLandingPage"
                className="search-bar__form"
                onSubmit={(e) => {
                  e.preventDefault()

                  if (selected_vacancyCountryTags == undefined || selected_vacancyCountryTags == '') {
                    if (isBeneluxOrNorthAmerica || isAustralia) {
                      selected_vacancyCountryTags = countryDummyFilterName
                      country = countryDummyFilterName
                    } else {
                      selected_vacancyCountryTags = isSelectedCountry ? localeCountry.getIn([lang]) : ''
                    }
                  }

                  let search = []

                  if (department != '' || department != undefined) {
                    search.push(
                      selected_vacancyDepartmentTags && selected_vacancyDepartmentTags != ''
                        ? 'vacancyDepartmentTag=' + encodeTag(selected_vacancyDepartmentTags)
                        : ''
                    )
                  }

                  if (country != '' || country != undefined) {
                    if (country == tagNorthAmerica) {
                      search.push(
                        selected_vacancyCountryTags && selected_vacancyCountryTags != ''
                          ? 'vacancyCountryTag=' + encodeTag('Canada')
                          : ''
                      )
                      search.push(
                        selected_vacancyCountryTags && selected_vacancyCountryTags != ''
                          ? 'vacancyCountryTag=' + encodeTag('United States')
                          : ''
                      )
                    } else if (country == tagBenelux) {
                      search.push(
                        selected_vacancyCountryTags && selected_vacancyCountryTags != ''
                          ? 'vacancyCountryTag=' + encodeTag('Belgium')
                          : ''
                      )
                      search.push(
                        selected_vacancyCountryTags && selected_vacancyCountryTags != ''
                          ? 'vacancyCountryTag=' + encodeTag('Netherlands')
                          : ''
                      )
                    } else {
                      search.push(
                        selected_vacancyCountryTags && selected_vacancyCountryTags != ''
                          ? 'vacancyCountryTag=' + encodeTag(selected_vacancyCountryTags)
                          : ''
                      )
                    }
                  }

                  const url = (
                    '/' +
                    getLangFromUrl() +
                    `/${translatedCareersSlug[lang]}/vacancies/0/?` +
                    search.join('&')
                  )
                    .replace(/\/\//g, '/')
                    .replace(/\/\//g, '/')
                  window.history.pushState({}, '', url)
                  var popStateEvent = new PopStateEvent('popstate', { state: {} })
                  dispatchEvent(popStateEvent)
                }}
              >
                <div className="search-bar__form-inner">
                  <div className="search-bar__group">
                    <label className={`search-bar__form-label text--${lang == 'de' ? 'm' : 'l'}`} htmlFor="id_select-2">
                      {t('LandingPage:would_like_to_work')}
                    </label>

                    <select
                      id="id_select-2"
                      className={`search-bar__dropdown text--${lang == 'de' ? 'm' : 'l'}`}
                      onChange={(e) => {
                        const val = e.currentTarget.value
                        selected_vacancyCountryTags = val
                        country = selected_vacancyCountryTags
                      }}
                    >
                      {isSelectedCountry || isBeneluxOrNorthAmerica ? (
                        <option disabled value="">
                          {t('LandingPage:select_region')}
                        </option>
                      ) : (
                        <option disabled selected value="">
                          {t(`LandingPage:select_region`)}
                        </option>
                      )}
                      {countries.map((c) =>
                        isSelectedCountry && localeCountry.getIn([lang]) == c ? (
                          <option selected value={c}>
                            {' '}
                            {t(
                              `search:tag_countryname:${c
                                .replace('&', '_')
                                .replace(',', '_')
                                .replace('-', '_')
                                .split(/\s/)
                                .join('')
                                .toLowerCase()}`
                            )}
                          </option>
                        ) : (
                          <option value={c}>
                            {' '}
                            {t(
                              `search:tag_countryname:${c
                                .replace('&', '_')
                                .replace(',', '_')
                                .replace('-', '_')
                                .split(/\s/)
                                .join('')
                                .toLowerCase()}`
                            )}
                          </option>
                        )
                      )}

                      {isBenelux && (
                        <option selected value={tagBenelux}>
                          {' '}
                          {t(
                            `search:tag_countryname:${tagBenelux
                              .replace('&', '_')
                              .replace(',', '_')
                              .replace('-', '_')
                              .split(/\s/)
                              .join('')
                              .toLowerCase()}`
                          )}
                        </option>
                      )}

                      {isNorthAmerica && (
                        <option selected value={tagNorthAmerica}>
                          {' '}
                          {t(
                            `search:tag_countryname:${tagNorthAmerica
                              .replace('&', '_')
                              .replace(',', '_')
                              .replace('-', '_')
                              .split(/\s/)
                              .join('')
                              .toLowerCase()}`
                          )}
                        </option>
                      )}

                      {isAustralia && (
                        <option selected value={tagAustralia}>
                          {' '}
                          {t(
                            `search:tag_countryname:${tagAustralia
                              .replace('&', '_')
                              .replace(',', '_')
                              .replace('-', '_')
                              .split(/\s/)
                              .join('')
                              .toLowerCase()}`
                          )}
                        </option>
                      )}
                    </select>
                  </div>

                  <div className="search-bar__group">
                    <label className={`search-bar__form-label text--${lang == 'de' ? 'm' : 'l'}`} htmlFor="id_select">
                      {t(`LandingPage:in`)}
                    </label>
                    <select
                      id="id_select"
                      className={`search-bar__dropdown text--${lang == 'de' ? 'm' : 'l'}`}
                      onChange={(event) => {
                        let val = event.currentTarget.value
                        selected_vacancyDepartmentTags = val
                        department = selected_vacancyDepartmentTags
                      }}
                    >
                      <option disabled selected value="">
                        {t('LandingPage:select_department')}
                      </option>
                      {departments.map((d) => (
                        <option value={d}>
                          {t(
                            `search:tag_${d
                              .replace('&', '_')
                              .replace(',', '_')
                              .replace('-', '_')
                              .split(/\s/)
                              .join('')
                              .toLowerCase()}`
                          )}
                        </option>
                      ))}
                    </select>
                    {lang == 'de' ? <span className="search-bar__form-span text--m">{'arbeiten'}</span> : null}
                  </div>
                </div>
                <button
                  form="formLandingPage"
                  className="search-bar__button button button--primary"
                  type="submit"
                  onClick={() => {
                    pushRefrescoDatalayer({
                      category: 'careers_header_button',
                      action: t(`LandingPage:find_vacancies`),
                      label: window.location.pathname
                    })
                  }}
                >
                  {t(`LandingPage:find_vacancies`)}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
